export default {
	/**
	 * Get the loading state.
	 *
	 * @param {Object} state
	 * @return {Boolean}
	 */
	loading(state) {
		return state.loading
	},

	/**
	 * Get the error state.
	 *
	 * @param {Object} state
	 * @return {Boolean}
	 */
	error(state) {
		return state.error
	},
}
